import { render, staticRenderFns } from "./stockManagement.vue?vue&type=template&id=1a21b9e9&scoped=true&"
import script from "./stockManagement.vue?vue&type=script&lang=js&"
export * from "./stockManagement.vue?vue&type=script&lang=js&"
import style0 from "./stockManagement.vue?vue&type=style&index=0&id=1a21b9e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a21b9e9",
  null
  
)

export default component.exports